import React, { Component } from 'react';
import { StyleSheet, css } from '../utility/paypalAphrodite';
import $ from 'jquery';

import templateData, { localsMessages } from '../utility/getTemplateData';
import { isLTR as isLeftToRight } from '../utility/helper';

const { contextLocalityDir } = templateData;
const messages = localsMessages('common/ppcc');
const isLTR = isLeftToRight();

const STYLES = StyleSheet.create({
	checkMark: {
		color: '#005EA6',
		cursor: 'pointer',
	},
	toolTip: {
		position: 'fixed',
		zIndex: 1,
	},
})

export default class PPCC extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isToolTipOpen: false,
		}
	}
	
	componentDidMount = () => {
		this.addToolTipListeners();
	}

	addToolTipListeners() {
		$('body').on('click', (event) => {
			if (event.target.id === 'ppccIcon') {
				return;
			}

			if (this.state.isToolTipOpen) {
				this.handleTipOut(event)
			}
		});

		$(window).on('scroll', (event) => {
			if (this.state.isToolTipOpen) {
				this.handleTipOut(event);
			}
		});
	 }

	getToolTipHelpIconPosition =() => {
		const tiphelpIcon = document.getElementById('ppccIcon');
		const tiphelpIconPosition = tiphelpIcon.getBoundingClientRect();
		const { top, left, width } = tiphelpIconPosition;

		return {
			top,
			center: left + (width / 2)
		};
	}
    
	getToolTipDimensions = () => {
		const toolTipBox = document.getElementById('ppcc-tooltip-box');
		const toolTipBoxHeight = toolTipBox.clientHeight;
		const toolTipBoxWidth = toolTipBox.clientWidth;

		return {
			toolTipBoxHeight,
			toolTipBoxWidth
		};
	}

	handleTipMove = (event) => {
		const widthOfToolTip = 272;
		const documentWidth = $(document).width();
		const toolTipBox = document.getElementById('ppcc-tooltip-box');
		$(toolTipBox).removeClass('hide');
		const {
			top,
			center: centerOfTipHelpIcon
		} = this.getToolTipHelpIconPosition();
		
		const {
			toolTipBoxHeight,
			toolTipBoxWidth
		} = this.getToolTipDimensions();
		
		// First position the tooltip
		const distanceOfTipHelpIconFromRightBorder = (documentWidth - centerOfTipHelpIcon);
		const isThereSpaceForToolTip = isLTR ? distanceOfTipHelpIconFromRightBorder > 136 : centerOfTipHelpIcon > 136;
		
		// Calculate left position
		let LTRtooltipLeft;
		let RTLtooltipLeft;

		if (isThereSpaceForToolTip) {

			LTRtooltipLeft = centerOfTipHelpIcon - (toolTipBoxWidth / 2)
			RTLtooltipLeft = centerOfTipHelpIcon + (toolTipBoxWidth / 2)
			if (LTRtooltipLeft < 0 || RTLtooltipLeft < 0) {

				LTRtooltipLeft = 30;
				RTLtooltipLeft = 30;
			}
		} else {
			// 30px from the document's right/left end
			LTRtooltipLeft = documentWidth - widthOfToolTip - 30;
			RTLtooltipLeft = documentWidth + widthOfToolTip - (documentWidth - 30);
		}

		// Position and center the tooltip on the help 
		$('#ppcc').css({
			'top': top - toolTipBoxHeight,
			'left': isLTR ? LTRtooltipLeft : RTLtooltipLeft // left of tooltip box
		});

		// Position the arrow for ltr/rtl
		const LTRarrowLeft = centerOfTipHelpIcon - LTRtooltipLeft;
		const RTLarrowLeft = isThereSpaceForToolTip ? centerOfTipHelpIcon - LTRtooltipLeft - 4 : centerOfTipHelpIcon - 34;

		$('.ppcc-arrow').css({
			'left': isLTR ? LTRarrowLeft : RTLarrowLeft
		});

		this.setState({
			isToolTipOpen: true
		});
	}

	handleTipOut = (event) => {
		let toolTipBox = document.getElementById('ppcc-tooltip-box');
		$(toolTipBox).addClass('hide');
		this.setState({
			isToolTipOpen: false
		});
	}

	handleToolTipIconClick(event) {
		if (this.state.isToolTipOpen) {
			this.handleTipOut(event);
		} else {
			this.handleTipMove(event);
		}
		event.preventDefault();
	}
	
	render = () => {
		return (
			<span>
				<span 
					className={`${css(STYLES.checkMark)} icon icon-small icon-positive-small`}
					onClick={(event) => this.handleToolTipIconClick(event)}
					id="ppccIcon"
				></span>
				<div id="ppcc" className={`tooltip_donate_wrapper ${css(STYLES.toolTip)}`}>
					<div className="tooltip top hide" id="ppcc-tooltip-box">
						<div className={`ppcc-arrow ${contextLocalityDir}`}></div>
						<div className="tooltip-inner">
							<p>{messages.ppcc.tooltip}</p>
						</div>
					</div>
				</div>
			</span>
		)
	}
}




// WEBPACK FOOTER //
// ./components/ppcc.js